<template>
  <Dialog
    v-model:visible="visibleModel"
    modal
    append-to="body"
    :style="{ width: '92vw', maxWidth: '1400px' }"
    :content-style="dialogContentStyle"
    class="attachment-r7-editor-dialog"
    @show="emit('shown')"
    @hide="emit('close')"
  >
    <template #header>
      <span class="attachment-r7-editor-dialog__title">{{ title }}</span>
    </template>

    <div class="attachment-r7-editor-dialog__body">
      <div v-if="error" class="attachment-r7-editor-dialog__error">{{ error }}</div>
      <div
        v-show="!error"
        :id="placeholderId"
        class="attachment-r7-editor-dialog__host"
      />
      <div v-if="loading" class="attachment-r7-editor-dialog__loading">Загрузка редактора…</div>
    </div>
  </Dialog>
</template>

<script setup lang="ts">
/**
 * Модальный контейнер для `DocsAPI.DocEditor` (WUI-305).
 * `placeholderId` — id DOM-узла, передаётся в useR7DocEditor / useAttachmentR7Editor.
 * События: `shown` (init editor), `close` (poll staging, destroy).
 */
import Dialog from 'primevue/dialog'
import { computed } from 'vue'

const props = defineProps<{
  visible: boolean
  title: string
  placeholderId: string
  loading?: boolean
  error?: string | null
}>()

const emit = defineEmits<{
  'update:visible': [value: boolean]
  shown: []
  close: []
}>()

const dialogContentStyle = {
  padding: 0,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column' as const,
  minHeight: '75vh',
  height: '75vh',
}

const visibleModel = computed({
  get: () => props.visible,
  set: (value: boolean) => emit('update:visible', value),
})
</script>

<style scoped>
.attachment-r7-editor-dialog__title {
  font-weight: 600;
}

.attachment-r7-editor-dialog__body {
  position: relative;
  flex: 1;
  min-height: 0;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  padding: 0 12px 12px;
}

.attachment-r7-editor-dialog__host {
  flex: 1;
  min-height: 0;
  width: 100%;
}

.attachment-r7-editor-dialog__host :deep(> div),
.attachment-r7-editor-dialog__host :deep(> iframe) {
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box;
}

.attachment-r7-editor-dialog__host :deep(iframe) {
  width: 100% !important;
  height: 100% !important;
  min-height: 100% !important;
  border: 0;
}

.attachment-r7-editor-dialog__error {
  padding: 1rem;
  color: var(--p-red-500, #c62828);
}

.attachment-r7-editor-dialog__loading {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.6);
  pointer-events: none;
}
</style>

<!-- Dialog append-to=body: оболочка .p-dialog вне scoped-дерева компонента. -->
<style>
.p-dialog.attachment-r7-editor-dialog {
  display: flex;
  flex-direction: column;
}

.p-dialog.attachment-r7-editor-dialog .p-dialog-content {
  flex: 1;
  min-height: 0;
  width: 100%;
  box-sizing: border-box;
  padding: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
</style>
